import { Loader2 } from "lucide-react";

const BUTTON_CLASSNAME =
  "inline-flex items-center justify-center gap-2 px-6 py-3 border border-zinc-700 bg-zinc-800/40 text-zinc-300 rounded-full font-medium btn-scale transition-colors hover:bg-zinc-800/70 hover:text-white hover:border-zinc-600 w-fit shrink-0 max-w-full disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-zinc-800/40 disabled:hover:text-zinc-300 disabled:hover:border-zinc-700";

/**
 * Controle inferior de paginação. Não substitui a grid por loading.
 *
 * @param {{
 *   onClick: () => void,
 *   loading?: boolean,
 *   disabled?: boolean,
 *   error?: boolean,
 *   dataTestId?: string,
 * }} props
 */
export function LoadMoreButton({
  onClick,
  loading = false,
  disabled = false,
  error = false,
  dataTestId = "load-more-btn",
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-8">
      {error ? (
        <p className="text-sm text-red-400 text-center" data-testid={`${dataTestId}-error`}>
          Não foi possível carregar mais itens. Tente novamente.
        </p>
      ) : null}
      <button
        type="button"
        onClick={onClick}
        disabled={disabled || loading}
        data-testid={dataTestId}
        className={BUTTON_CLASSNAME}
      >
        {loading ? <Loader2 size={16} className="animate-spin" /> : null}
        {loading ? "Carregando..." : "Carregar mais"}
      </button>
    </div>
  );
}
